// Module
var code = "<div class=\"vui-global-loading-indicator\" ng-if=\"$ctrl.showLoading\">\n    <vui-progress-circular></vui-progress-circular>\n</div>";
// Exports
module.exports = code;